export class VaultService {
	storage = localStorage;

	setItem<T>(key: string, value: T): void {
		try {
			return this.storage.setItem(key, JSON.stringify(value));
		} catch (e) {
			console.warn('e: ', e);
		}
	}

	removeItem(key: string): void {
		this.storage.removeItem(key);
	}

	getItem<T = string>(key: string): T | null {
		const value = this.storage.getItem(key);
		
		if (value === null) {
			return null;
		}

		try {
			return JSON.parse(value) as T;
		} catch {
			// La valeur n'est pas du JSON valide, retourner la valeur brute
			return value as unknown as T;
		}
	}

	clearStorage(): void {
		this.storage.clear();
	}
}
